/* eslint-disable react/prop-types */
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AdminContext } from "../context/AdminContext";

const ProtectedRoute = ({ requiredRole, requiredAccess, children }) => {
  const { aToken, isSuperAdmin, hasAdminAccess } = useContext(AdminContext);

  if (!aToken) {
    return <Navigate to="/mogzitAdmin" />;
  }

  // Check both AdminContext state (async) and localStorage (sync)
  // This prevents race conditions where a super_admin is redirected away
  // upon deep-linking or refreshing the page before fetchAdminProfile completes.
  const storedRole = localStorage.getItem("role");
  if (requiredRole === "superAdmin" && !isSuperAdmin && storedRole !== "super_admin") {
    return <Navigate to="/admins/dashboard" />;
  }

  if (
    requiredAccess &&
    typeof hasAdminAccess === "function" &&
    !hasAdminAccess(requiredAccess)
  ) {
    return <Navigate to="/admins/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;
